const formatTags = require("../../dict/formatTags.js");
module.exports = function replaceItalicTags(text, openTag, closeTag){
    let openPattern = new RegExp(formatTags.italics.open, "gmi"),
        closePattern = new RegExp(formatTags.italics.close, "gmi")
    return text.replace(openPattern,openTag).replace(closePattern, closeTag);
}